<div class="Main-container">
	<div class="scheduler-TB">
		<div class="contentInside memeb-form" style="float: left; width: 100%;">
			<div *ngIf="isLoading; else content" class="spinner__loading">
				<mat-spinner></mat-spinner>
			</div>
			<ng-template #content>
				<div class="t-b-ara">
					<button n-submit class="btn btn-primary pull-right" (click)="openDialog()">Add Service Address</button>
				</div>
				<div class="MT-Availability">
					<mat-tab-group>
						<div *ngFor=" let serviceAddress of serviceAddress">
							<mat-tab label="{{serviceAddress}}"> </mat-tab>
						</div>
					</mat-tab-group>
				</div>

				<form [formGroup]="fg" *ngFor="let fg of availablityForms.controls;let index = index;"
					(submit)="submitRecords(availablityForms)" class="avai-form">
					<div class="col-md-12  availability grid-table">
						<div class="tbody mt15">
							<div class="col-md-3 td">
								<label class="bold-label">Type*</label>
								<mat-select class="form-control" formControlName="visitTypeId" placeholder="Select Type" #select>
									<mat-option *ngFor="let type of appointmenTypes" [value]="type.num">{{type.name}}</mat-option>
								</mat-select>
								<mat-error *ngIf="checkControlInvalidTouchedDirty(fg, 'visitTypeId')">
									<small class="text-danger" *ngIf="fg.get('visitTypeId').errors.required">
										Type is required
									</small>
								</mat-error>
								<div *ngIf="select.value == '1'" class="mt15">
									<label class="bold-label">Select Address*</label>
									<mat-select class="form-control" formControlName="serviceAddress" placeholder="Select Address">
									  <mat-option *ngFor="let serviceAddress of serviceAddress" [value]="serviceAddress">
										{{ serviceAddress }}
									  </mat-option>
									</mat-select>
									<mat-error *ngIf="checkControlInvalidTouchedDirty(fg, 'serviceAddress')">
									  <small class="text-danger" *ngIf="fg.get('serviceAddress').errors.required">
										Address is required.
									  </small>
									</mat-error>
								</div>
								<div *ngIf="select.value == '2'"  class="mt15">
									<label class="bold-label">Select Client*</label>
									<mat-select
									  class="form-control"
									  formControlName="clientId"
									  placeholder="Select Client"
									  (selectionChange)="onClientSelectionChange($event, index)">
									  <mat-option *ngFor="let clientName of clientsList" [value]="clientName.clientId">
										{{clientName.clientName}}
									  </mat-option>
									</mat-select>
									<mat-error *ngIf="checkControlInvalidTouchedDirty(fg, 'clientId')">
									  <small class="text-danger" *ngIf="fg.get('clientId').errors.required">
										Client is required.
									  </small>
									</mat-error>
								</div>
								<div *ngIf="select.value == '2' && isClientSelected" class="mt15">
									<label class="bold-label">Select Project*</label>
									<mat-select
									  class="form-control"
									  formControlName="projectId"
									  placeholder="Select Project">
									  <mat-option *ngFor="let projectName of projectList" [value]="projectName.projectId">
										{{projectName.projectName}}
									  </mat-option>
									</mat-select>
									<mat-error *ngIf="checkControlInvalidTouchedDirty(fg, 'projectId')">
									  <small class="text-danger" *ngIf="fg.get('projectId').errors.required">
										Project is required.
									  </small>
									</mat-error>
								  </div>

							  </div>

							<div class="col-md-2 td">
								<label class="bold-label">Time Zone*</label>
								<mat-select class="form-control" formControlName="timeZone" placeholder="Select Type" >
								  <mat-option *ngFor="let timeZone of timeZones" [value]="timeZone.name">{{timeZone.name}}</mat-option>
								</mat-select>
								<mat-error *ngIf="checkControlInvalidTouchedDirty(fg, 'timeZone')">
								  <small class="text-danger" *ngIf="fg.get('timeZone').errors.required">
									Time Zone is required.
								  </small>
								</mat-error>
							  </div>

							<div class="col-md-2 td date-container">
								<label class="bold-label">Date range*</label>
								<input class="form-control date-input" placeholder="Select Date" ngModel bsDaterangepicker
									[minDate]="minDate" [maxDate]="maxDate" formControlName="avaiDate"
									(bsValueChange)="onSelecetionDateChange($event, index)"
									[bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }">
								<mat-error *ngIf="checkControlInvalidTouchedDirty(fg, 'avaiDate')">
									<small class="text-danger" *ngIf="fg.get('avaiDate').errors.required">
										Date range is required.
									</small>
								</mat-error>
							</div>
							<div class="col-md-2 td">
								<label class="bold-label">Start Time*</label>
								<input type="time" formControlName="startTime" value="07/20/2020" />
								<mat-error *ngIf="checkControlInvalidTouchedDirty(fg, 'startTime')">
									<small class="text-danger" *ngIf="fg.get('startTime').errors.required">
										Start time is required.
									</small>
								</mat-error>
								<mat-error *ngIf="checkInvalidTime(index)">
									Start time must be earlier than end time.
								</mat-error>
							</div>
							<div class="col-md-2 td">
								<label class="bold-label">End Time*</label>
								<input type="time" formControlName="endTime" value="07/20/2020" />
								<mat-error *ngIf="checkControlInvalidTouchedDirty(fg, 'endTime')">
									<small class="text-danger" *ngIf="fg.get('endTime').errors.required">
										End time is required.
									</small>
								</mat-error>
								<mat-error *ngIf="checkInvalidTime(index)">
									End time must be later than start time.
								</mat-error>
							</div>

							<div class="col-md-1 td text-right">
								<button n-submit class="remove-AD-btn" [disabled]="availablityForms.controls.length < 2"
									(click)="onRemoveRow(index)"><span class="add-ico"><i
											class="fa fa-times-circle times-circle" aria-hidden="true"></i>
									</span></button>
							</div>
							<div class="width100 mt30 btn-block add-btn-block"
									*ngIf="index === availablityForms.controls.length - 1">
								<div class="button-container">
									<button n-submit class="btn reset-button" (click)="resetFg()">Reset</button>
									<button n-submit type="button" (click)="addPreference()" class="btn btn-primary">
									<i class="fa fa-plus-circle" aria-hidden="true"></i> Add Preference
									</button>
								</div>
							</div>
						</div> <!-- t Body-->
					</div> <!-- table -->
				</form>
				<!--form closed-->
				<div class="width100 mt30 btn-block add-btn-block text-center submit-btn-availibilty">
					<button n-submit type="submit" class="btn btn-primary" (click)="submitRecords(availablityForms)" [disabled]="availablityForms.pristine">
						<i class="fa fa-plus-circle" aria-hidden="true"></i>
							SUBMIT
						</button>
				</div>
        <div class="S-Calendar" style="float: left; width: 100%; ">
          <app-slot-calendar *ngIf="openCalender" [providerAvailability]='providerAvailability'></app-slot-calendar>
        </div>
			</ng-template>
		</div>
	</div>
</div>
